import React from 'react';
import Webcam from 'react-webcam';

import Alert from '@material-ui/lab/Alert';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';


import ButtonComponent from 'components/buttons/button';
import IntlMessageComponent from 'components/formatters/intlMessage';
import MandatoryFormFieldsComponent from 'components/form/mandatory';
import PageSubTitleViewComponent from 'components/pageTitle/subTitle';
import UploadFileFieldComponent from 'components/formFields/upload/index';
import TooltipComponent from 'components/toolTips/index';

import Document from 'models/documents/v2/document';
import DocumentType from 'models/documents/documentType';

type SubscriptionTabKycViewComponentProps = {
  documents: Document[];
  isProcessing: boolean;
  registrationTypeId: number;
  showExplanation: boolean;
  takenPhoto: image;
  startKyc: () => void;
  takePhoto: () => void;
  retakePhoto: () => void;
  handleDocumentSetPhoto: () => void;
}

export default function SubscriptionTabKycViewComponent(props: SubscriptionTabKycViewComponentProps) {
  const documentToTakePhoto = props.documents.find(d => d.isProvided === false);
  const webcamRef = React.useRef(null);
  const capture = React.useCallback(
    () => {
      props.takePhoto(webcamRef.current.getScreenshot());
    },
    [webcamRef]
  );
  const videoConstraints = {
    facingMode: "user"
  };

  return (
    <React.Fragment>
      <PageSubTitleViewComponent id="page.subscription.tabkyc.h2" data-walkme="subscription-title-documents" />

      {props.showExplanation &&
        <Box p={2}>
          <Box>
            <IntlMessageComponent id="page.subscription.tabkyc.explanation" /><br /><br />
          </Box>

          <Box pb={3}>
            <Alert severity="info">
              <b><IntlMessageComponent id="page.subscription.tabkyc.warning" /></b>
            </Alert>
          </Box>


          <ButtonComponent
            color="primary"
            variant="contained"
            isProcessing={props.isProcessing}
            onClick={props.startKyc}
          ><IntlMessageComponent id="page.subscription.tabkyc.startkyc" /></ButtonComponent>
        </Box>
      }

      {props.showMidProcessExplanation &&
        <Box p={2}>
          <Box pt={2}>
            <IntlMessageComponent id="page.subscription.tabkyc.intructions" /><br /><br />
            <ul style={{ lineHeight: '1.8em', marginBottom: '25px' }}>
              <li><IntlMessageComponent id="page.subscription.tabkyc.intruction1" /></li>
              <li><IntlMessageComponent id="page.subscription.tabkyc.intruction2" /></li>
              <li><IntlMessageComponent id="page.subscription.tabkyc.intruction3" /></li>
              <li><IntlMessageComponent id="page.subscription.tabkyc.intruction4" /></li>
              <li><IntlMessageComponent id="page.subscription.tabkyc.intruction5" /></li>
              <li><IntlMessageComponent id="page.subscription.tabkyc.intruction6" /></li>
            </ul>
          </Box>

          <ButtonComponent
            color="primary"
            variant="contained"
            isProcessing={props.isProcessing}
            onClick={props.startKyc}
          ><IntlMessageComponent id="page.subscription.tabkyc.continuekyc" /></ButtonComponent>
        </Box>
      }

      {!props.showExplanation && !props.showMidProcessExplanation && documentToTakePhoto !== null && props.takenPhoto === null &&
        <Box p={2}>
          <Box>
            <Alert severity="info">
              <IntlMessageComponent id={"page.subscription.tabkyc.explanation" + documentToTakePhoto.code} />
            </Alert>
          </Box>
          <Box pt={2}>
            <Webcam
              audio={false}
              ref={webcamRef}
              forceScreenshotSourceSize
              screenshotFormat="image/jpeg"
              width={100 + '%'}
              videoConstraints={videoConstraints}
            />
          </Box>
          <Box pt={2}>
            <ButtonComponent
              color="primary"
              variant="contained"
              isProcessing={props.isProcessing}
              onClick={capture}
            ><IntlMessageComponent id={"page.subscription.tabkyc.takephoto"} /></ButtonComponent>
          </Box>
        </Box>
      }

      {!props.showExplanation && !props.showMidProcessExplanation && documentToTakePhoto !== null && props.takenPhoto !== null &&
        <Box p={2}>
          <Box >
            <IntlMessageComponent id={"page.subscription.tabkyc.confirmphoto"} />
          </Box>

          <Box pt={2}>
            <img width={100 + '%'} src={props.takenPhoto}></img>
          </Box>

          <Box pt={2}>
            <ButtonComponent
              color="white"
              variant="outlined"
              isProcessing={props.isProcessing}
              onClick={props.retakePhoto}
            ><IntlMessageComponent id="page.subscription.tabkyc.retakephoto" /></ButtonComponent>
            <Box component="span" ml={1}>
              <ButtonComponent
                color="primary"
                variant="contained"
                isProcessing={props.isProcessing}
                onClick={() => props.handleDocumentSetPhoto(documentToTakePhoto.code)}
              ><IntlMessageComponent id="page.subscription.tabkyc.confirmphotobutton" /></ButtonComponent>
            </Box>
          </Box>
        </Box>
      }

    </React.Fragment>
  );
}